import { makeStyles } from "@material-ui/core/styles";

const sequencerHeaderStyles = makeStyles((theme) => ({
  viewHeaderRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 8px 8px 12px",
    height: "55px",
    boxSizing: "border-box",
    backgroundColor: theme.palette.secondary.light,
    flexShrink: 0,
  },
  viewHeaderTitle: {
    fontWeight: 500,
    fontSize: "16px",
    color: "#F9F9F9",
    letterSpacing: "0.7px",
  },
  viewHeaderRight: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0,
  },
  viewHeaderBackButton: {
    color: "#F9F9F9",
    textTransform: "none",
    fontSize: "13px",
    minWidth: "0",
    padding: "6px 8px",
    "&:hover": {
      backgroundColor: "transparent",
      color: "#F9F9F999",
    },
  },
  viewToggleGroup: {
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "8px",
    gap: "4px",
  },
  viewToggleActive: {
    backgroundColor: "#6C65D9",
    color: "#F9F9F9",
    borderRadius: "6px",
    padding: "6px 14px",
    fontSize: "12px",
    textTransform: "none",
    minWidth: "0",
    "&:hover": {
      backgroundColor: "#554BB8",
    },
  },
  viewToggleInactive: {
    backgroundColor: "transparent",
    color: theme.palette.text.tertiary,
    borderRadius: "6px",
    padding: "6px 14px",
    fontSize: "12px",
    textTransform: "none",
    minWidth: "0",
    "&:hover": {
      backgroundColor: "#252A38",
    },
  },
  shareButton: {
    border: "2px solid #6C65D9",
    [theme.breakpoints.down(1537)]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.up(1537)]: {
      fontSize: "12px !important",
    },
  },
  exportButton: {
    backgroundColor: "#6C65D9",
    color: "white",
    [theme.breakpoints.down(1537)]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.up(1537)]: {
      fontSize: "12px !important",
    },
  },
}));

export default sequencerHeaderStyles;
